import Common from '../../../Common';

interface Body {
	adsync_field_name: string
	type: ContactField
	label: string
	sync_mode: AdSyncFieldSyncMode
}
export interface CompanyAdSyncUserField {
	id: id
	adsync_id: id
	adsync_field_name: string
	type: string
	label: string
	sync_mode: AdSyncFieldSyncMode
}

const UserField = class extends Common {
	browse = (companyId: id, adSyncId: id): CustomResponse<AdSyncUserField[]> =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/user/field`)

	create = (companyId: id, adSyncId: id, body: Body) =>
		this.post(`/company/${companyId}/adsync/${adSyncId}/user/field`, body)

	update = (companyId: id, adSyncId: id, id: id, body: Body) =>
		this.patch(`/company/${companyId}/adsync/${adSyncId}/user/field/${id}`, body)

	delete = (companyId: id, adSyncId: id, id: id) =>
		this.doDelete(`/company/${companyId}/adsync/${adSyncId}/user/field/${id}`)

	allKeys = (companyId: id, adSyncId: id): CustomResponse<AdSyncUserFieldKey[]> =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/user/field/key`)
}

export default UserField
